export enum SectionCode {
    TextilHogar = "12",
    Ferreteria = "13",
    MenajeYDeco = "16",
    Outdoor = "23",
    ElectroHogar = "39",
    BañosYCocinas = "41",
    Construccion = "43",
    Herramientas = "45",
    Automotor = "46",
    Muebles = "47",
    Pinturas = "48",
    Flooring = "49",
    Iluminacion = "50",
    Electricidad = "51",
    JardinYMascotas = "53",
    PuertasYVentanas = "56",
    Maderas = "57",
    Plomeria = "58",
    OrganizacionYLimpieza = "59",
    AmpolletasYTubos = "64",
}


export enum TaskEnumBreakAdjustment {
    BREAKADJUSTMENTALERT = 'BREAKADJUSTMENTALERT',
    BREAKADJUSTMENTALERTFORAPPROVE = 'BREAKADJUSTMENTALERTFORAPPROVE'
};

export enum TaskStateEnumBreakAdjustment {
    PENDING = 'PENDING',
    REVIEWED = 'REVIEWED',
    COMPLETED = 'COMPLETED',
    REJECTED = 'REJECTED',
    CANCELLED = 'CANCELLED',
    MODIFIED = 'MODIFIED',
    EXPIRED = 'EXPIRED',
}

export enum TabTaskType {
    Completed = 'COMPLETED',
    Expired = 'EXPIRED',
}